import { FC } from 'react';

import { SearchConsoleAnalyticsDimensionsKeys, SearchConsoleAnalyticsDimensionTypes } from '@/modules/Domains';

import { CountriesLabel } from './CountriesLabel';
import { DatesLabel } from './DatesLabel';
import { DevicesLabel } from './DevicesLabel';
import { PagesLabel } from './PagesLabel';
import { QueriesLabel } from './QueriesLabel';
import { SearchAppearancesLabel } from './SearchAppearancesLabel';

type Props = {
  [K in SearchConsoleAnalyticsDimensionsKeys]: {
    dimension: K;
    value: SearchConsoleAnalyticsDimensionTypes[K]['key'];
  }
}[SearchConsoleAnalyticsDimensionsKeys];

export const TableKeyValueLableHoc: FC<Props> = ({ dimension, value }) => {
  if (dimension === 'dates') return <DatesLabel value={ value }/>;
  if (dimension === 'queries') return <QueriesLabel value={ value }/>;
  if (dimension === 'countries') return <CountriesLabel value={ value }/>;
  if (dimension === 'devices') return <DevicesLabel value={ value }/>;
  if (dimension === 'pages') return <PagesLabel value={ value }/>;
  if (dimension === 'searchAppearances') return <SearchAppearancesLabel value={ value }/>;
  return <></>;
};
